// Generated responsive per-breakpoint typography tokens
// Internal-only: not part of public package exports.
// Consumers should NOT use breakpoint-specific tokens directly.
// Instead, use the aggregated responsive tokens exposed from src/tokens/typography.generated.ts.
export const common = {
    fontFamily: 'AudiType, sans-serif',
    textDecoration: 'none',
    letterSpacing: '0px'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '40px',
    lineHeight: '60px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '40px',
    lineHeight: '60px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '48px',
    lineHeight: '68px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '60px',
    lineHeight: '84px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '72px',
    lineHeight: '100px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_2XL = {
    ...common,
    fontWeight: '400',
    fontSize: '84px',
    lineHeight: '112px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '44px',
    lineHeight: '60px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '52px',
    lineHeight: '76px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '60px',
    lineHeight: '84px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_2XL = {
    ...common,
    fontWeight: '400',
    fontSize: '72px',
    lineHeight: '100px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '32px',
    lineHeight: '48px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '32px',
    lineHeight: '48px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '44px',
    lineHeight: '64px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '52px',
    lineHeight: '76px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_2XL = {
    ...common,
    fontWeight: '400',
    fontSize: '60px',
    lineHeight: '84px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '40px',
    lineHeight: '60px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_2XL = {
    ...common,
    fontWeight: '400',
    fontSize: '44px',
    lineHeight: '64px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_XS = {
    ...common,
    fontWeight: '700',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_SM = {
    ...common,
    fontWeight: '700',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_MD = {
    ...common,
    fontWeight: '700',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_LG = {
    ...common,
    fontWeight: '700',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_XL = {
    ...common,
    fontWeight: '700',
    fontSize: '40px',
    lineHeight: '60px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_2XL = {
    ...common,
    fontWeight: '700',
    fontSize: '44px',
    lineHeight: '64px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '32px',
    lineHeight: '44px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_2XL = {
    ...common,
    fontWeight: '400',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_XS = {
    ...common,
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_SM = {
    ...common,
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_MD = {
    ...common,
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_LG = {
    ...common,
    fontWeight: '700',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_XL = {
    ...common,
    fontWeight: '700',
    fontSize: '32px',
    lineHeight: '44px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_2XL = {
    ...common,
    fontWeight: '700',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_2XL = {
    ...common,
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XS = {
    ...common,
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_SM = {
    ...common,
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_MD = {
    ...common,
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_LG = {
    ...common,
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XL = {
    ...common,
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_2XL = {
    ...common,
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '28px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_2XL = {
    ...common,
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XS = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_SM = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_MD = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_LG = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XL = {
    ...common,
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '28px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_2XL = {
    ...common,
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
//# sourceMappingURL=responsive-typography.generated.js.map